<script lang="ts">
    // TODO: rdar://78161351 (<ButtonAction> and <ClickAction> improvements)
    import { type Action, isFlowAction } from '~/jet/models';
    import {
        clickAction,
        isCompoundExternalAction,
        isCompoundFlowAction,
        isExternalAction,
    } from '~/actions/click-action';
    import { extractActionHref } from '~/jet/utils';

    export let action: Action | null = null;
    export let ariaLabel: string = null;
    export let disabled: boolean = false;
</script>

{#if isFlowAction(action) || isCompoundFlowAction(action)}
    <a
        data-testid="click-action"
        class="click-action"
        href={extractActionHref(action) || '#'}
        aria-label={ariaLabel}
        use:clickAction={action}
    >
        <slot />
    </a>
{:else if isExternalAction(action) || isCompoundExternalAction(action)}
    <a
        data-testId="click-action"
        class="click-action"
        href={extractActionHref(action) || '#'}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={ariaLabel}
        use:clickAction={action}
    >
        <slot />
    </a>
{:else if action}
    <button
        data-testId="click-action"
        class="click-action"
        aria-label={ariaLabel}
        {disabled}
        use:clickAction={action}
    >
        <slot />
    </button>
{:else}
    <slot />
{/if}

<style lang="scss">
    button {
        display: block;
        width: 100%;
        text-align: inherit;
        color: var(--linkColor, inherit);

        &[disabled] {
            opacity: 0.7;
            cursor: default;
        }
    }
</style>
